import { Component, OnInit } from '@angular/core';
import { FormEditorBase } from './../../../../../models/forms/formEditor.base';

@Component({
  selector: 'swb-dropdown',
  templateUrl: './dropdown.component.html'
})
export class DropdownComponent extends FormEditorBase implements OnInit {

  ngOnInit() {
  }

}
